(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-paddle-new"] && !Shopify.designMode) return;
  try {
    

  let temp = "";
  
  setTimeout(() => {
  while (!jQuery) {}
  jQuery(document).ready(() => {
    jQuery('.selected-face-color-input').on('click', (e) => {
      let temp = $(e.target).val();
      $('.straightLine').css('fill', temp); 
    });

    jQuery('.selected-grip-color-input').on('click', (e) => {
      let temp = $(e.target).val();
      $('.straightLineGrip').css('fill', temp); 
      $('#color_stripe_2').val(temp);
    });

    jQuery('.selected-face-color-input').on('change', (e) => {
      let temp = $(e.target).val();
      $('.straightLine').css('fill', temp); 
      $('#colorPickerLabel').css('backgroundColor', temp); 
      $('#color_stripe_1').val(temp);
    });

    jQuery('.selected-grip-color-input').on('change', (e) => {
      let temp = $(e.target).val();
      $('.straightLineGrip').css('fill', temp); 
      $('#colorPickerLabel2').css('backgroundColor', temp); 
      $('#color_stripe_2').val(temp);
    });

    jQuery('.selected-face-color-input').on('input', (e) => {
      let temp = $(e.target).val();
      $('.straightLine').css('fill', temp); 
      $('#colorPickerLabel').css('backgroundColor', temp); 
      $('#color_stripe_1').val(temp);
    });

    jQuery('.selected-grip-color-input').on('input', (e) => {
      let temp = $(e.target).val();
      $('.straightLineGrip').css('fill', temp); 
      $('#colorPickerLabel2').css('backgroundColor', temp); 
      $('#color_stripe_2').val(temp);
    });

    jQuery('.selected-main-face-color-input').on('click', (e) => {
      let temp = $(e.target).val();
      $('.faceBg').css('fill', temp); 
    });

    jQuery('#backSide').on('click', (e) => {
      $('#backside').removeClass('dNone');
      $('#backside').css('display', 'block !important');
      $('#backside').show();
      $('#frontside').addClass('dNone');
      $('#frontside').css('display', 'none !important');
      $('#frontside').hide();
    });

    jQuery('#frontSideBack').on('click', (e) => {
      $('#frontside').removeClass('dNone');
      $('#frontside').css('display', 'block !important');
      $('#frontside').show();
      $('#backside').addClass('dNone');
      $('#backside').css('display', 'none !important');
      $('#backside').hide();
    });


    
    jQuery('.selected-face-color-input-back').on('click', (e) => {
      let temp = $(e.target).val();
      $('.straightLineBack').css('fill', temp); 
    });

    jQuery('.selected-grip-color-input-back').on('click', (e) => {
      let temp = $(e.target).val();
      $('.straightLineGripBack').css('fill', temp); 
      $('#color_stripe_2_back').val(temp);
    });

    jQuery('.selected-face-color-input-back').on('change', (e) => {
      let temp = $(e.target).val();
      $('.straightLineBack').css('fill', temp); 
      $('#colorPickerLabelBack').css('backgroundColor', temp); 
      $('#color_stripe_1Back').val(temp);
    });

    jQuery('.selected-grip-color-input-back').on('change', (e) => {
      let temp = $(e.target).val();
      $('.straightLineGripBack').css('fill', temp); 
      $('#colorPickerLabel2Back').css('backgroundColor', temp); 
      $('#color_stripe_2_back').val(temp);
    });

    jQuery('.selected-face-color-input-back').on('input', (e) => {
      let temp = $(e.target).val();
      $('.straightLineBack').css('fill', temp); 
      $('#colorPickerLabelBack').css('backgroundColor', temp); 
      $('#color_stripe_1_back').val(temp);
    });

    jQuery('.selected-grip-color-input-back').on('input', (e) => {
      let temp = $(e.target).val();
      $('.straightLineGripBack').css('fill', temp); 
      $('#colorPickerLabel2Back').css('backgroundColor', temp); 
      $('#color_stripe_2_back').val(temp);
    });

    jQuery('#backSide').on('click', (e) => {
      $('#backside').removeClass('dNone');
      $('#backside').css('display', 'block !important');
      $('#backside').show();
      $('#frontside').addClass('dNone');
      $('#frontside').css('display', 'none !important');
      $('#frontside').hide();
      $('.frontS').hide();
      $('.backS').show();
      $('.backS').removeClass('dNone');
    });

    jQuery('#frontSideBack').on('click', (e) => {
      $('#frontside').removeClass('dNone');
      $('#frontside').css('display', 'block !important');
      $('#frontside').show();
      $('#backside').addClass('dNone');
      $('#backside').css('display', 'none !important');
      $('#backside').hide();
      $('.frontS').show();
      $('.backS').hide();
    });
      
  });

  document.getElementById('colorPickerLabel').addEventListener('click', function() {
    document.getElementById('face-color-main').jscolor.show();  // Open JScolor picker
  });

  document.getElementById('colorPickerLabelStripe2').addEventListener('click', function() {
    document.getElementById('face-color-main-grip').jscolor.show();  // Open JScolor picker
  });

  document.getElementById('colorPickerLabelBack').addEventListener('click', function() {
    document.getElementById('face-color-main-back').jscolor.show();  // Open JScolor picker
  });

  const swiper = new Swiper('.swiper', {
    loop: true,
  
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },
  
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  
    // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });


  }, 1800);


  setTimeout(() => {
    while (!jQuery) {}
    jQuery(document).ready(function() {


      let file = document.getElementById("logoInput");
      let back = document.getElementById("imageSrc2");
      
      file.addEventListener('change', function() {
        let files = this.files;
        let dt = new DataTransfer();
        for(let i=0; i<files.length; i++) {
          let f = files[i];
          dt.items.add(
            new File(
              [f.slice(0, f.size, f.type)],
              f.name
          ));
        }
        back.files = dt.files;
      });

      
      jQuery('#logoInput').change(function() {
        var file = this.files[0];
        if (file) {
          var reader = new FileReader();
          reader.onload = function(e) {
            jQuery('#logoPreview').html('<img src="' + e.target.result + '" alt="Logo">');
            temp = e.target.result;
            jQuery('#imageInSvg').attr('href', e.target.result);
          };
          reader.readAsDataURL(file);

          $('.straightLineGrip').css('fill', '#fff'); 
          $('.straightLine').css('fill', '#fff'); 
          $('.lineUp').css('fill', '#fff'); 
        }
      });
    });
    }, 2000);

  setTimeout(() => {
      const picker = document.querySelector('.jscolor');
      if (picker) {
          picker.style.padding = '0!important';
      }
  }, 500);  // Delay to ensure JScolor has generated the picker


  
  document.addEventListener('DOMContentLoaded', function () {
    var fileInput = document.getElementById('image');
    var paddleImage = document.querySelector('.paddle-container .logo');
    var paddleDataForm = document.getElementById('paddleDataForm');
    var submitButton = document.getElementById('requestBtn');
    var contactForm = document.getElementById('ContactForm');
    var selectedFaceColor = document.querySelector('selected-face-color');
    var selectedGripColor = document.querySelector('selected-grip-color');

    /*document.getElementById('face-color-2').classList.remove('color-options input');*/
    selectedFaceColor.addEventListener('click', (e) => {
      console.log("Test");
    })

    fileInput.addEventListener('change', function () {
      previewImage();
    });

    submitButton.addEventListener('click', function (e) {
      createFormDataMessage();
    });

    function previewImage() {
      var file = fileInput.files[0];

      if (file) {
        var reader = new FileReader();

        reader.onload = function (e) {
          paddleImage.src = e.target.result;
          document.getElementById("imageSrc").value = e.target.result;
          document.getElementById("imageSrc2").value = e.target.result;
          paddleImage.style.display = "block";
        };

        reader.readAsDataURL(file);
      }
    }

    function createFormDataMessage() {
      var formData = new FormData(paddleDataForm);
      var data = {};
      var message = document.getElementById('ContactForm-body');
      var messageText = '';

      formData.forEach((value, key) => {
        messageText += key + ': ' + value + '\n';
      });

      message.value = messageText;
      contactForm.submit();
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-paddle-request"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var fileInput = document.getElementById('image');
    var paddleImage = document.querySelector('.paddle-container .logo');
    var paddleDataForm = document.getElementById('paddleDataForm');
    var submitButton = document.getElementById('requestBtn');
    var contactForm = document.getElementById('ContactForm');

    fileInput.addEventListener('change', function () {
      previewImage();
    });

    submitButton.addEventListener('click', function (e) {
      createFormDataMessage();
    });

    function previewImage() {
      var file = fileInput.files[0];

      if (file) {
        var reader = new FileReader();

        reader.onload = function (e) {
          paddleImage.src = e.target.result;
          document.getElementById("imageSrc").value = e.target.result;
          paddleImage.style.display = "block";
        };

        reader.readAsDataURL(file);
      }
    }

    function createFormDataMessage() {
      var formData = new FormData(paddleDataForm);
      var data = {};
      var message = document.getElementById('ContactForm-body');
      var messageText = '';

      formData.forEach((value, key) => {
        messageText += key + ': ' + value + '\n';
      });

      message.value = messageText;
      contactForm.submit();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
